interface FinancingIconProps {
  className?: string;
}

export function FinancingIcon({ className }: FinancingIconProps) {
  return (
    <svg
      width='1em'
      height='1em'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden
    >
      <rect x='1.25' y='4.25' width='15.5' height='9.5' rx='1' stroke='currentColor' strokeWidth='1.5' />
      <circle cx='5' cy='9' r='0.75' fill='currentColor' />
      <circle cx='9' cy='9' r='2.25' stroke='currentColor' strokeWidth='1.5' />
      <circle cx='13' cy='9' r='0.75' fill='currentColor' />
    </svg>
  );
}
